import React, { Component } from 'react';
import {
    Box,
    Typography,
    Paper,
    TextField,
    Grid,
    MenuItem,
    Button
} from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';

const inputStyle = {
    '& .MuiOutlinedInput-root': { borderRadius: '10px', bgcolor: 'white' }
};

export default class StoreAddress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cep: '',
            rua: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            estado: '',
            latitude: '',
            longitude: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }



    componentDidMount() {
        var { cep, rua, numero, complemento, bairro, cidade, estado, latitude, longitude } = this.props.data;
        this.setState({ cep, rua, numero, complemento, bairro, cidade, estado, latitude, longitude });
    }

    // Função para buscar dados na API do ViaCEP
    buscarCep(cepLimpo) {
        fetch("https://api.fazpedido.app/search-address/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "company": "pizzaria_uniao" // Passando dinamicamente
            },
            body: JSON.stringify({
                cep: cepLimpo,
                numero: 1,
                complemento: ""
            })
        }).then(res => res.json())
            .then(data => {
                if (!data.erro) {
                    // Preenche os campos com o retorno da API
                    this.setState({
                        rua: data.rua || '',
                        bairro: data.bairro || '',
                        cidade: data.cidade || '',
                        estado: data.estado || '',
                        latitude: data.latitude || '',
                        longitude: data.longitude || ''
                    });
                } else {
                    alert('CEP não encontrado.');
                }
            })
            .catch(err => {
                console.error('Erro ao buscar o CEP:', err);
            });
    }

    handleChange(event) {
        const { name, value } = event.target;

        // Lógica específica para o campo CEP
        if (name === 'cep') {
            // Remove tudo o que não for número (ex: remove o hífen se o usuário colar "01310-200")
            const cepLimpo = value.replace(/\D/g, '');

            // Atualiza o estado do CEP (limita a visualização em até 8 dígitos)
            this.setState({ [name]: cepLimpo.slice(0, 8) });

            // Se completou os 8 números do CEP, dispara a busca
            if (cepLimpo.length === 8) {
                this.buscarCep(cepLimpo);
            }
            return;
        }

        // Comportamento normal para os demais campos
        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        fetch(`${process.env.REACT_APP_API_URL}/settings/address`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state),
        })
            .then(response => {
                if (response.ok) {
                    toast.success('Endereço atualizado com sucesso!');
                } else {
                    toast.error('Erro ao atualizar o endereço.');
                }
            })
            .catch(error => {
                console.error('Erro ao atualizar o endereço:', error);
            });
    }

    render() {
        return (
            <Box
                component="form"
                onSubmit={this.handleSubmit}
                sx={{ p: 0, margin: '0 auto', }}
            >
                {/* Título Endereço */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <LocationOnOutlinedIcon sx={{ fontSize: 20, mr: 1, color: '#666' }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Endereço
                    </Typography>
                </Box>

                {/* Container de CEP de Origem */}
                <Paper
                    elevation={0}
                    sx={{
                        p: 3,
                        mb: 4,
                        borderRadius: '12px',
                        border: '1px solid #e0d5f5',
                        backgroundColor: '#fdfbfe'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, color: '#6200ee' }}>
                        <LocalShippingOutlinedIcon sx={{ fontSize: 18, mr: 1 }} />
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            CEP de Origem *
                        </Typography>
                    </Box>

                    <TextField
                        name="cep"
                        value={this.state.cep}
                        onChange={this.handleChange}
                        placeholder="Apenas números (Ex: 01310200)"
                        size="small"
                        inputProps={{ maxLength: 8 }} // Evita digitação de mais de 8 caracteres
                        sx={{
                            width: '240px',
                            mb: 2,
                            '& .MuiOutlinedInput-root': { borderRadius: '10px', bgcolor: 'white' }
                        }}
                    />

                    <Typography variant="caption" sx={{ display: 'block', color: '#666', lineHeight: 1.4 }}>
                        <strong>Obrigatório para cálculo de fretes.</strong> O CEP será usado como origem para calcular o frete de entrega no catálogo público. Ao digitar os 8 números, a rua, bairro, cidade e estado serão preenchidos automaticamente.
                    </Typography>
                </Paper>

                {/* Grid de Logradouro e Número */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={8}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Rua / Logradouro</Typography>
                        <TextField
                            fullWidth
                            name="rua"
                            size="small"
                            placeholder="Av. Brasil"
                            value={this.state.rua}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Número</Typography>
                        <TextField
                            fullWidth
                            name="numero"
                            size="small"
                            placeholder="123"
                            value={this.state.numero}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>

                {/* Grid de Complemento e Bairro */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Complemento</Typography>
                        <TextField
                            fullWidth
                            name="complemento"
                            size="small"
                            placeholder="Sala 101, Bloco A"
                            value={this.state.complemento}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Bairro</Typography>
                        <TextField
                            fullWidth
                            name="bairro"
                            size="small"
                            placeholder="Centro"
                            value={this.state.bairro}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>

                {/* Grid de Cidade e Estado */}
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Cidade</Typography>
                        <TextField
                            fullWidth
                            name="cidade"
                            size="small"
                            placeholder="São Paulo"
                            value={this.state.cidade}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Estado</Typography>
                        <TextField
                            select
                            fullWidth
                            name="estado"
                            size="small"
                            value={this.state.estado}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            <MenuItem value="AC">Acre</MenuItem>
                            <MenuItem value="AL">Alagoas</MenuItem>
                            <MenuItem value="AP">Amapá</MenuItem>
                            <MenuItem value="AM">Amazonas</MenuItem>
                            <MenuItem value="BA">Bahia</MenuItem>
                            <MenuItem value="CE">Ceará</MenuItem>
                            <MenuItem value="DF">Distrito Federal</MenuItem>
                            <MenuItem value="ES">Espírito Santo</MenuItem>
                            <MenuItem value="GO">Goiás</MenuItem>
                            <MenuItem value="MA">Maranhão</MenuItem>
                            <MenuItem value="MT">Mato Grosso</MenuItem>
                            <MenuItem value="MS">Mato Grosso do Sul</MenuItem>
                            <MenuItem value="MG">Minas Gerais</MenuItem>
                            <MenuItem value="PA">Pará</MenuItem>
                            <MenuItem value="PB">Paraíba</MenuItem>
                            <MenuItem value="PR">Paraná</MenuItem>
                            <MenuItem value="PE">Pernambuco</MenuItem>
                            <MenuItem value="PI">Piauí</MenuItem>
                            <MenuItem value="RJ">Rio de Janeiro</MenuItem>
                            <MenuItem value="RN">Rio Grande do Norte</MenuItem>
                            <MenuItem value="RS">Rio Grande do Sul</MenuItem>
                            <MenuItem value="RO">Rondônia</MenuItem>
                            <MenuItem value="RR">Roraima</MenuItem>
                            <MenuItem value="SC">Santa Catarina</MenuItem>
                            <MenuItem value="SP">São Paulo</MenuItem>
                            <MenuItem value="SE">Sergipe</MenuItem>
                            <MenuItem value="TO">Tocantins</MenuItem>
                        </TextField>
                    </Grid>
                </Grid>

                {/* Localização no Mapa */}
                <Box sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <MapOutlinedIcon sx={{ fontSize: 20, mr: 1, color: '#666' }} />
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Localização no Mapa</Typography>
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                        A localização permite que clientes vejam sua loja no mapa do catálogo público.
                    </Typography>
                </Box>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Latitude</Typography>
                        <TextField
                            fullWidth
                            name="latitude"
                            size="small"
                            value={this.state.latitude}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Longitude</Typography>
                        <TextField
                            fullWidth
                            name="longitude"
                            size="small"
                            value={this.state.longitude}
                            sx={inputStyle}
                            onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>

                {/* Container de Botões no rodapé */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        startIcon={<MapOutlinedIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            borderColor: '#e0e0e0',
                            color: '#333',
                            '&:hover': { borderColor: '#bdbdbd', bgcolor: '#f5f5f5' }
                        }}
                    >
                        Selecionar no mapa
                    </Button>

                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<SaveOutlinedIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar Endereço
                    </Button>
                </Box>
            </Box>
        );
    }
}